<script lang="ts">
import { computed, defineComponent, getCurrentInstance, inject } from "vue";
import IconSprite from "@/components/IconSprite.vue";

export default defineComponent({
  name: "Ueberschrift",
  components: { IconSprite },
  props: {
    titel: String,
    breite: {
      type: Number,
      default: 4,
    },
    abstandOben: {
      type: Number,
      default: 1,
    },
    gridDivId: {
      type: String,
      default: "",
    },
    ausrichtungResponsiv: {
      type: Boolean,
      default: true,
    },
    zeigeInfo: {
      type: Boolean,
      default: false,
    },
    infoBoxId: {},
  },
  setup(props) {
    const instance = getCurrentInstance();
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");

    const gridKlassen = computed(() => {
      return "o-grid u-mar-t-" + props.abstandOben;
    });

    const zellenKlassen = computed(() => {
      return (
        "o-grid__cell o-grid__cell--12 o-grid__cell--" +
        props.breite +
        "-1024" +
        (props.ausrichtungResponsiv ? " u-text-align-right--1024" : "") +
        (!instance?.parent?.props.spacingY ? " u-form-grid-nospace-y" : "")
      );
    });

    const infoClick = () => {
      wechsleSichtbarkeit(props.infoBoxId);
    };

    return {
      gridKlassen,
      zellenKlassen,
      infoClick,
    };
  },
});
</script>

<template>
  <div :id="gridDivId" :class="gridKlassen">
    <div :class="zellenKlassen">
      <h2 class="u-form-heading">
        {{ titel }}
        <slot></slot>
        <span v-if="zeigeInfo && infoBoxId" class="c-notice-icon" title="Hilfe anzeigen" @click="infoClick">
          <icon-sprite icon-name="icon-info-i" />
        </span>
      </h2>
    </div>
  </div>
</template>
